var React = require('react');

function ContentX2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",null,[React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeDasharray":"0 0 12 2","strokeMiterlimit":"10","cx":"17.5","cy":"27.62","r":"15.66","key":0}),React.createElement("g",{"key":1},[React.createElement("path",{"d":"m11.96,27.2l-1.49-2.15h1.42l.8,1.18.79-1.18h1.38l-1.49,2.12,1.68,2.41h-1.42l-.95-1.43-.95,1.43h-1.4l1.63-2.39h0Z","key":0}),React.createElement("path",{"d":"m16.07,26.35c-.07-2.09,1.12-3.69,3.31-3.69,1.67,0,3.13,1.07,3.13,2.86,0,2.76-2.93,2.99-4.26,4.86h4.32v1.59h-6.7c0-2.12,1.3-3,2.88-4.08.8-.56,1.92-1.11,1.92-2.23,0-.87-.57-1.41-1.37-1.41-1.1,0-1.45,1.13-1.45,2.1h-1.78Z","key":1})])])));
}

ContentX2.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 35.14 43.78"};

module.exports = ContentX2;

ContentX2.default = ContentX2;
